export default __webpack_public_path__ + "static/media/tomoimage.2d00b804.png";